import VinculadorSimples from "../../../../../Components/Table/Vinculador";
import {
    DesvincularUsuarioHelpdeskGerenciaController,
    ListarUsuariosDesvinculadosController,
    ListarUsuariosVinculadosController,
    VincularUsuarioHelpdeskGerenciaController,
} from "../../../../../Controllers/HelpDesk/Equipes/EquipesGerenciaController";

interface UsuariosProps {
    ID_FILA: number;
}

export function Gerencia(props: UsuariosProps) {
    return (
        <VinculadorSimples
            id={props.ID_FILA}
            title="Telas por grupo"
            listarVinculados={ListarUsuariosVinculadosController}
            listarNaoVinculados={ListarUsuariosDesvinculadosController}
            acoes={{
                desvincular: (U) =>
                    DesvincularUsuarioHelpdeskGerenciaController(
                        U.ID_EQUIPE_GERENCIA || 0
                    ),
                vincular: (idEquipeGerencia, usuario) =>
                    VincularUsuarioHelpdeskGerenciaController({
                        ID_EQUIPE_HELP_DESK: idEquipeGerencia,
                        ID_USUARIO: usuario.ID_USUARIO,
                        ID_EQUIPE_GERENCIA: 0,
                    }),
            }}
            tabelaVinculados={{
                text: "Usuários Vinculadas",
                dataField: "DS_NOME",
                key: "ID_USUARIO",
            }}
            tabelaDesvinculados={{
                text: "Usuários desvinculadas",
                dataField: "DS_NOME",
                key: "ID_USUARIO",
            }}
        />
    );
}
